import { useQuery, useQueryClient } from "react-query";
import { CATEGORIES, USERS } from "../../config/apiConfig";
import axios from "../../config/axiosInstance";
import { Badge, Button, Card, Pagination, Modal, Table } from "flowbite-react";
import { useApplication } from "../../contexts/ApplicationContext";
import { useState } from "react";
import { Icon } from "@mui/material";
import { IoMdAdd } from "react-icons/io";
import CardLoading from "../CardLoading";
import TableLoading from "../TableLoading";
import { getFirstLettersName } from "../../utils/utils";
import { TbLockSearch } from "react-icons/tb";
// import Drawer from "../Drawer"; // ⛔️ removido
import UserQueriesForm from "../forms/UserQueriesForm";
import UserForm from "../forms/UserForm";
import { MdEmail, MdNumbers } from "react-icons/md";
import ModalDelete from "../modals/ModalDelete";
import { BsPencil } from "react-icons/bs";
import { HiTrash } from "react-icons/hi";

const UsersTable = () => {
  const { userPermission } = useApplication();
  const [currentPage, setCurrentPage] = useState(1);
  const queryClient = useQueryClient();
  const [isDrawerPermissionQueries, setIsDrawerPermissionQueries] =
    useState(false);
  const [isDrawerOpenUser, setIsDrawerOpenUser] = useState(false);
  const [isOpenModalDelete, setOpenModalDelete] = useState(false);
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);

  const [totalPages, setTotalPages] = useState(1);
  const [selectedUser, setSelectedUser] = useState(null);
  const [typeDrawer, setTypeDrawer] = useState("CREATE");
  const onPageChange = (page) => setCurrentPage(page);

  const {
    isLoading,
    error,
    data: users,
  } = useQuery(["users", currentPage], async () => {
    const { data: items } = await axios.get(
      `${USERS.GET_USERS}?page=${currentPage}`
    );
    setTotalPages(items.data.totalPages || 1);
    return items.data.data;
  });

  const {
    isLoadingCategories,
    error: errorCategories,
    data: categories,
  } = useQuery(["categories", currentPage], async () => {
    const { data } = await axios.get(
      `${CATEGORIES.GET_ALL}?page=${currentPage}`
    );
    return data.data.data;
  });

  const handleAddProfessional = () => {
    setSelectedUser(null);
    setTypeDrawer("CREATE");
    setIsDrawerOpenUser(true);
  };

  const handleEditUserQueriesPermission = (user) => {
    setSelectedUser(user);
    setIsDrawerPermissionQueries(true);
  };

  const handleEditUser = (user) => {
    setTypeDrawer("EDIT");
    setSelectedUser(user);
    setIsDrawerOpenUser(true);
  };

  const handleDeleteUser = (user) => {
    setSelectedUser(user);
    setOpenModalDelete(true);
  };

  const deleteUser = async () => {
    try {
      setIsLoadingDelete(true);
      await axios.delete(`${USERS.GET_USER}/${selectedUser.id}`);
      queryClient.invalidateQueries(["users", currentPage]);
      setOpenModalDelete(false);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoadingDelete(false);
    }
  };

  return (
    <>
      {userPermission !== "USER" && (
        <div className="flex justify-end mb-3 mt-2">
          <Button
            className="primary ml-auto md:ml-0 mb-5 md:mb-0 fixed md:relative bottom-4 md:bottom-0 right-6 md:right-0 z-10 md:z-0 rounded-full md:rounded-md shadow-lg md:shadow-md h-14 md:h-auto w-14 md:w-auto flex md:block justify-center items-center"
            variant="contained"
            disabled={isLoading ? true : false}
            onClick={handleAddProfessional}
          >
            <IoMdAdd className="block md:hidden text-2xl" />
            <span className="hidden md:block">Adicionar usuário</span>
          </Button>
        </div>
      )}

      {/* Mobile: Cards */}
      <div className="grid grid-cols-1 gap-5 mb-6 mt-4 md:hidden">
        {!isLoading
          ? users.map((user, index) => (
              <div
                key={index}
                className="group relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-4 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg"
              >
                {/* Header */}
                <div className="flex items-start gap-3">
                  {/* Avatar */}
                  {!user?.imageUrl ? (
                    <div
                      className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-white"
                      style={{ background: `var(--primary)` }}
                    >
                      <span className="text-sm font-semibold">
                        {getFirstLettersName(user.name)}
                      </span>
                    </div>
                  ) : (
                    <img
                      src={user.imageUrl}
                      alt={user.name}
                      className="h-12 w-12 shrink-0 rounded-full object-cover"
                    />
                  )}

                  {/* Nome + badges */}
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <h3 className="truncate text-base font-semibold text-slate-800">
                        {user?.name}
                      </h3>
                      {user?.isActive ? (
                        <span className="inline-flex items-center rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-semibold text-emerald-700 ring-1 ring-emerald-200">
                          Ativo
                        </span>
                      ) : (
                        <span className="inline-flex items-center rounded-full bg-rose-50 px-2 py-0.5 text-[11px] font-semibold text-rose-700 ring-1 ring-rose-200">
                          Inativo
                        </span>
                      )}
                      {user?.permissionId === "ADMIN" && (
                        <span className="inline-flex items-center rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-semibold text-slate-700 ring-1 ring-slate-200">
                          Admin
                        </span>
                      )}
                    </div>

                    {/* Email */}
                    <div className="mt-1 flex items-center gap-2 text-sm text-slate-500">
                      <MdEmail className="opacity-70" />
                      <span className="truncate">{user.email}</span>
                    </div>

                    {/* Código de acesso */}
                    <div className="mt-1 flex items-center gap-2 text-sm text-slate-500">
                      <MdNumbers className="opacity-70" />
                      <span className="truncate">
                        Cod. Acesso: {user.accessCode || "-"}
                      </span>
                    </div>

                    {/* Limite de consultas */}
                    <div className="mt-1 text-xs text-slate-500">
                      Limite/mês: {user?.monthlyRequestLimit ?? "-"}
                    </div>
                  </div>
                </div>

                {/* Footer / Ações */}
                <div className="mt-4 flex items-center justify-between">
                  {/* Permissão rápida (somente se não for admin/power-user) */}
                  <div className="opacity-80">
                    {["ADMIN", "POWER_USER"].includes(userPermission) &&
                      !["ADMIN", "POWER_USER"].includes(user?.permissionId) && (
                        <button
                          type="button"
                          onClick={() => handleEditUserQueriesPermission(user)}
                          className="inline-flex items-center gap-1.5 rounded-lg border border-slate-200 bg-slate-50 px-3 py-1.5 text-xs font-medium text-slate-700 transition hover:bg-slate-100 hover:text-slate-900"
                          title="Permissões de consulta"
                        >
                          <TbLockSearch className="text-[16px]" />
                          Permissões
                        </button>
                      )}
                  </div>

                  {/* Botões editar/excluir */}
                  <div className="flex items-center gap-3">
                    <button
                      type="button"
                      onClick={() => handleEditUser(user)}
                      className="rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 shadow-sm transition hover:bg-slate-50 hover:shadow"
                      title="Editar"
                    >
                      Editar
                    </button>

                    {users?.length > 1 && (
                      <button
                        type="button"
                        onClick={() => handleDeleteUser(user)}
                        className="rounded-lg border border-rose-200 bg-rose-50 px-3 py-1.5 text-xs font-semibold text-rose-700 shadow-sm transition hover:bg-rose-100 hover:shadow"
                        title="Excluir"
                      >
                        Excluir
                      </button>
                    )}
                  </div>
                </div>

                {/* Accent bar (estético) */}
                <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1 scale-x-0 bg-[var(--primary)] opacity-70 transition-transform duration-200 group-hover:scale-x-100" />
              </div>
            ))
          : Array.from({ length: 12 }).map((_, index) => (
              <CardLoading key={index} />
            ))}
      </div>

      {/* Desktop: Tabela */}
      <div className="hidden md:block mb-6 mt-4">
        <div className="overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm">
          <div className="overflow-x-auto">
            <Table hoverable striped className="text-xs xl:text-sm">
              <Table.Head className="sticky top-0 bg-gray-100">
                <Table.HeadCell className="text-left bg-gray-100 text-gray-700">
                  Usuário
                </Table.HeadCell>
                <Table.HeadCell className="text-center bg-gray-100 text-gray-700">
                  E-mail
                </Table.HeadCell>
                <Table.HeadCell className="text-center bg-gray-100 text-gray-700">
                  Código de acesso
                </Table.HeadCell>
                <Table.HeadCell className="text-center bg-gray-100 text-gray-700">
                  Limite/mês
                </Table.HeadCell>
                <Table.HeadCell className="text-center bg-gray-100 text-gray-700">
                  Status
                </Table.HeadCell>
                <Table.HeadCell className="text-center bg-gray-100 text-gray-700">
                  Ações
                </Table.HeadCell>
              </Table.Head>
              <Table.Body className="divide-y">
                {!isLoading ? (
                  users.map((user, index) => (
                    <Table.Row
                      key={index}
                      className="bg-white hover:bg-slate-50 transition"
                    >
                      <Table.Cell className="py-2">
                        <div className="flex items-center gap-3">
                          <div className="min-w-0 flex items-center gap-3">
                            <div className="truncate font-semibold text-slate-800">
                              {user?.name}
                            </div>
                            <div className="mt-0.5 flex items-center gap-2">
                              {user?.permissionId === "ADMIN" && (
                                <span className="inline-flex items-center rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-semibold text-slate-700 ring-1 ring-slate-200">
                                  Admin
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </Table.Cell>
                      <Table.Cell className="text-center py-2">
                        <a
                          href={`mailto:${user.email}`}
                          className="text-gray-700 hover:underline"
                        >
                          <span className="truncate inline-block max-w-[240px]">
                            {user.email}
                          </span>
                        </a>
                      </Table.Cell>
                      <Table.Cell className="text-center py-2">
                        {user.accessCode ? (
                          <code className="rounded bg-gray-100 px-2 py-0.5 text-[11px] font-semibold text-gray-800">
                            {user.accessCode}
                          </code>
                        ) : (
                          <span className="text-gray-400">—</span>
                        )}
                      </Table.Cell>
                      <Table.Cell className="text-center py-2">
                        <span className="text-gray-800">
                          {user?.monthlyRequestLimit ?? "—"}
                        </span>
                      </Table.Cell>
                      <Table.Cell className="text-center py-2">
                        {user?.isActive ? (
                          <span className="inline-flex items-center rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-semibold text-emerald-700 ring-1 ring-emerald-200">
                            Ativo
                          </span>
                        ) : (
                          <span className="inline-flex items-center rounded-full bg-rose-50 px-2 py-0.5 text-[11px] font-semibold text-rose-700 ring-1 ring-rose-200">
                            Inativo
                          </span>
                        )}
                      </Table.Cell>
                      <Table.Cell className="text-center py-2">
                        <div className="flex items-center justify-center gap-2">
                          {["ADMIN", "POWER_USER"].includes(userPermission) &&
                            !["ADMIN", "POWER_USER"].includes(
                              user?.permissionId
                            ) && (
                              <button
                                type="button"
                                onClick={() =>
                                  handleEditUserQueriesPermission(user)
                                }
                                className="inline-flex items-center gap-1 rounded-lg border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium text-slate-700 transition hover:bg-slate-100"
                                title="Permissões de consulta"
                              >
                                <TbLockSearch className="text-[14px]" />
                              </button>
                            )}
                          <button
                            type="button"
                            onClick={() => handleEditUser(user)}
                            className="rounded-lg border border-slate-200 bg-white px-2.5 py-1 text-[11px] font-semibold text-slate-700 shadow-sm transition hover:bg-slate-50"
                            title="Editar"
                          >
                            <BsPencil />
                          </button>
                          {users?.length > 1 && (
                            <button
                              type="button"
                              onClick={() => handleDeleteUser(user)}
                              className="rounded-lg border border-rose-200 bg-rose-50 px-2.5 py-1 text-[11px] font-semibold text-rose-700 shadow-sm transition hover:bg-rose-100"
                              title="Excluir"
                            >
                              <HiTrash />
                            </button>
                          )}
                        </div>
                      </Table.Cell>
                    </Table.Row>
                  ))
                ) : (
                  <TableLoading cols={5} />
                )}
              </Table.Body>
            </Table>
          </div>
        </div>
      </div>

      {totalPages > 1 && (
        <div className="flex overflow-x-auto justify-center mt-3">
          <Pagination
            layout="pagination"
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
            previousLabel=""
            nextLabel=""
            showIcons
          />
        </div>
      )}

      {/* ===== Modal: Criar/Editar Usuário ===== */}
      <Modal
        show={isDrawerOpenUser}
        size="4xl" // xs, sm, md, lg, xl, 2xl, 3xl, 4xl, 5xl, 6xl, 7xl
        onClose={() => setIsDrawerOpenUser(false)}
        popup
      >
        <Modal.Header>
          <div className="px-4 py-3 text-base -mt-1">
            {typeDrawer === "CREATE"
              ? "Criar usuário"
              : `Editar usuário: ${selectedUser?.name?.split(" ")[0] || ""}`}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="max-h-[70vh] overflow-y-auto pr-3">
            <UserForm
              user={selectedUser}
              onClose={setIsDrawerOpenUser}
              isOpen={isDrawerOpenUser}
              type={typeDrawer}
              fetchUsers={() => {
                queryClient.invalidateQueries(["users"]);
              }}
            />
          </div>
        </Modal.Body>
      </Modal>

      {/* ===== Modal: Permissões de Consulta ===== */}
      <Modal
        show={isDrawerPermissionQueries}
        size="3xl"
        onClose={() => setIsDrawerPermissionQueries(false)}
        popup
      >
        <Modal.Header>
          <div className="px-4 py-3 text-base -mt-1">
            {`Permissões de consultas para ${
              selectedUser?.name?.split(" ")[0] || ""
            }`}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="max-h-[70vh] overflow-y-auto pr-1">
            <UserQueriesForm
              user={selectedUser}
              categories={categories}
              onClose={setIsDrawerPermissionQueries}
              isOpen={isDrawerPermissionQueries}
            />
          </div>
        </Modal.Body>
      </Modal>

      <ModalDelete
        handleDelete={deleteUser}
        isOpen={isOpenModalDelete}
        setOpenModal={setOpenModalDelete}
        title="Tem certeza que deseja excluir esse usuário?"
        isLoading={isLoadingDelete}
      />
    </>
  );
};

export default UsersTable;
